(function($) {
    $(document).ready(function() {

        $.fn.projectListHover = function(duration) {
            var self = this;
            this.wrapper = $(this);
            this.items = this.wrapper.find('li');
            this.itemsLength = 4;

            this._moveItems = function(index,length) {
                if(index === 0) {
                    self.items.filter(':nth-child(2)').css('left', 27.5 + '%');
                    self.items.filter(':nth-child(3)').css('left', 52.5 + '%');
                    self.items.filter(':nth-child(4)').css('left', 77.5 + '%');
                } else if(index === 1) {
                    self.items.filter(':nth-child(1)').css('left', -1.25 + '%');
                    self.items.filter(':nth-child(2)').css('left', 23.75 + '%');
                    self.items.filter(':nth-child(3)').css('left', 51.25 + '%');
                    self.items.filter(':nth-child(4)').css('left', 76.25 + '%');
                } else if(index === 2) {
                    self.items.filter(':nth-child(1)').css('left', -1.25 + '%');
                    self.items.filter(':nth-child(2)').css('left', 23.75 + '%');
                    self.items.filter(':nth-child(3)').css('left', 48.75 + '%');
                    self.items.filter(':nth-child(4)').css('left', 76.25 + '%');
                } else {
                    self.items.filter(':nth-child(1)').css('left', -2.5 + '%');
                    self.items.filter(':nth-child(2)').css('left', 22.5 + '%');
                    self.items.filter(':nth-child(3)').css('left', 47.5 + '%');
                    self.items.filter(':nth-child(4)').css('left', 72.5 + '%');
                }
            };

            this._backMoveItems = function(index) {
                self.items.filter(':nth-child(1)').css('left', 0 + '%');
                self.items.filter(':nth-child(2)').css('left', 25 + '%');
                self.items.filter(':nth-child(3)').css('left', 50 + '%');
                self.items.filter(':nth-child(4)').css('left', 75 + '%');
            };

            this.items.each(function(key,value) {
                var itemKey = key;
                if(window.innerWidth > 768) {
                    $(value).hover(function() {
                        self._moveItems(itemKey);
                    },function() {
                        self._backMoveItems(itemKey);
                    });
                }
            });
        };

        if($('body').is(':has(.js-project-list)')) {
            $('.js-project-list').each(function() {
                $(this).projectListHover(2.5);
            });
        }
    });
})(jQuery);
